'use client';

import NumberFlow, { continuous } from '@number-flow/react';

type Props = {
  style: 'currency' | 'decimal' | 'percent';
  value: number;
};

// 🎑 View
export default function AnimateValue({ style, value }: Props) {
  return (
    <NumberFlow
      plugins={[continuous]}
      value={value}
      trend={+1}
      format={
        style === 'currency'
          ? {
              style: 'currency',
              currencyDisplay: 'symbol',
              currency: 'USD',
              minimumFractionDigits: 0,
              maximumFractionDigits: 2,
            }
          : {
              style: 'decimal',
              minimumFractionDigits: 0,
              maximumFractionDigits: 2,
            }
      }
      suffix={style === 'percent' ? '%' : undefined}
    />
  );
}
